module.exports = __webpack_public_path__ + "static/img/16060C_1_2_C_20210407_fit.f25a653.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16060C_1_2_C_20210407_fit.png
// module id = /rP+
// module chunks = 0